import { FC, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import useNotifications from '../../../utils/notifications/useNotifications'
import FormActions from '../../../components/FormActions'
import useCulture from '../../../utils/culture'
import useUi from '../../../core/ui/useUi'
import HistoryModal from './HistoryModal'
import useTermsConsVersions from '../../../core/termsConsVersions/useTermsConsVersions'

import './styles.scss'

const TermsConsVersions: FC = () => {
  const { t } = useTranslation()
  const { formatDate } = useCulture()
  const { showConfirmation } = useUi()
  const notify = useNotifications()
  const { current, fetchCurrent, createTermsConsVersion } =
    useTermsConsVersions()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [showHistory, setShowHistory] = useState<boolean>(false)

  const handleSaveConfirmation = () =>
    showConfirmation({
      title: t('termsCons.versions.saveConfirmation.title'),
      subtitle: t('termsCons.versions.saveConfirmation.subtitle'),
      iconName: 'report_problem',
      confirmText: t('common.publish'),
      cancelText: t('common.cancel'),
      onConfirm: handleCreate,
    })

  const handleCreate = () => {
    setIsSubmitting(true)
    try {
      createTermsConsVersion()
      notify.success(t('termsCons.versions.successFeedback'))
    } catch (e) {
    } finally {
      setIsSubmitting(false)
    }
  }

  useEffect(() => {
    fetchCurrent()
  }, [])

  return (
    <>
      <div className="TermsConsVersions">
        <div className="d-flex justify-content-between TermsConsVersions__content">
          <div>
            <div className="TermsConsVersions__header-values d-flex">
              <div>
                <span>{t('termsCons.code')}:</span> {current?.code}
              </div>
              <div>
                <span>{t('termsCons.date')}:</span>{' '}
                {current?.creationDate &&
                  formatDate(
                    new Date(current?.creationDate as string) as Date,
                    'LONG_DATE_TIME'
                  )}
              </div>
              <div>
                <span>{t('termsCons.author')}:</span> {current?.author}
              </div>
            </div>
          </div>
        </div>
        <FormActions>
          <button
            className="btn btn-outline-primary"
            onClick={() => setShowHistory(true)}
          >
            {t('termsCons.versions.changeHistory')}
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSaveConfirmation}
            disabled={isSubmitting}
          >
            {t('termsCons.versions.newVersion')}
          </button>
        </FormActions>
      </div>
      {showHistory && <HistoryModal onClose={() => setShowHistory(false)} />}
    </>
  )
}

export default TermsConsVersions
